const _ = require('./enum');
module.exports = {
  [_.MOBILE]: { id: _.MOBILE, label: 'Mobile' },
  [_.LAPTOP]: { id: _.LAPTOP, label: 'Laptop' },
  [_.DESKTOP]: { id: _.DESKTOP, label: 'Desktop' },
  [_.TABLET]: { id: _.TABLET, label: 'Tablet' },
};
